<!-- 标注中心右侧-项目任务信息 -->
<template>
  <div :class="['mark-center-right', excessive?'excessive':'']" :style="isFullScreen?'zIndex: 965;':''">
    <div class="right-tab">
      <span><i class="icon-public-task"></i>项目任务</span>
      <!-- <span><i class="icon-full-screen"></i></span> -->
      <span class="el-icon-d-arrow-right" v-if="!excessive" @click="onExcessive"></span>
      <span class="el-icon-d-arrow-left" v-else @click="onExcessive"></span>
    </div>
    <ai-book-task-two
      :curriculumId="curriculumId"
      :modelType="modelType"
      :Train.sync="trainingDetails"
      :trainingId="trainingId"
      :teacherOrStudentState="teacherOrStudentState"
      @getTrainingByTrainingId="getTrainingByTrainingId"
      @onIsFullScreen="onIsFullScreen"
      :trainModelShow="trainModelShow"
      :withdrawReleaseStatus="withdrawReleaseStatus"
    />
  </div>
</template>

<script>
import aiBookTaskTwo from './components/aiBookTaskTwo';

export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'MarkCenterRight',
  components: { aiBookTaskTwo },
  props: {
    // 课程
    curriculumId: {
      type: String,
      default: ''
    },
    // 实训详情
    trainingDetails: {
      type: Object,
      default: {},
    },
    cancelPopupShow: {
      type: Boolean,
      default: false,
    },
    teacherOrStudentState: {
      type: Boolean,
      default: false,
    },
    modelType: {
      type: String,
      default: '1'
    },
    trainModelShow: {
      type: Boolean,
      default: false,
    },
    withdrawReleaseStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFullScreen: false,
      excessive: false,
      trainingId:'',
      popupActive: '', // 弹窗
      popup: {
        title: {
          edit: '编辑实训',
          create: '添加实训',
        },
        btnTxt: {
          edit: '确定',
          create: '添加',
        },
      },
      NewProject: {
        trainingId: '',
        ProjectName: '',
        ProjectContent: '',
        ProjectType: '',
      },
      rules: {
        ProjectName: [{ required: true, message: '请填写项目名称' }],
        ProjectContent: [{ required: true, message: '请输入任务描述' }],
        ProjectType: [{ required: true, message: '请选择项目类型' }],
      },
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    trainingDetails(val) {
      if (val) {
        this.trainingDetails = val
        this.trainingId = this.trainingDetails.trainingId
      }
    },
    cancelPopupShow(val) {
      if (val) {
        this.cancelPopup()
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  methods: {
    onIsFullScreen(val) {
      this.isFullScreen = val
    },
    onExcessive() {
      this.excessive = !this.excessive
    },
    getTrainingByTrainingId() {
      this.$emit('getTrainingByTraining')
    },
    onModifyProjectName() {
      this.NewProject = {
        trainingId: this.trainingDetails.trainingId,
        ProjectName: this.trainingDetails.trainingName,
        ProjectContent: this.trainingDetails.trainingContent,
        ProjectType: this.trainingDetails.type,
      }
      this.popupActive = 'edit'
    },
    // 编辑项目，创建项目 + 编辑项目
    projectEdite() {
      this.$refs.popupUploadForm.validate((valid) => {
        if (valid) {
          if (this.popupActive === 'create') {
            // 新增
            // this.createNewProject()
          } else if (this.popupActive === 'edit') {
            // 编辑
            this.$emit('editeProject', this.NewProject)
          }
        } else {
          this.$message.error('请将项目相关内容填写完整')
        }
      })
    },
    // 取消弹窗
    cancelPopup() {
      if (/(create|edit)/.test(this.popupActive)) {
        this.NewProject = {
          trainingId: '',
          ProjectName: '',
          ProjectContent: '',
          ProjectType: '',
        }

        this.$refs.popupUploadForm.resetFields()
      }

      this.popupActive = ''
    },
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
div,
p {
  box-sizing: border-box;
  line-height: 1;
}

.mark-center-right {
  width: 340px;
  // height: 590px;
  height: calc(100% - 214px);
  padding-bottom: 42px;
  background: #ffffff;
  border: 1px solid #e3e3e3;
  box-shadow: 0px 2px 6px 0px rgba(15, 15, 17, 0.05);
  position: fixed;
  top: 110px;
  right: 0;
  transition: width 0.5s;
  // z-index: 997;
  z-index: 47;
  .right-tab {
    height: 40px;
    display: flex;
    text-align: center;
    span:nth-child(1) {
      // width: 258px;
      flex: 1;
      height: 40px;
      background: #e3eaf8;
      padding-top: 10px;
      box-sizing: border-box;
      .icon-public-task {
        display: inline-block;
        width: 16px;
        height: 18px;
        background: url('../../../assets/images/ai-editor/public-task.png')
          no-repeat;
        // border: 2px solid #ffffff;
        // border-radius: 3px;
        vertical-align: bottom;
        margin-right: 13px;
      }
    }
    span:nth-child(2) {
      width: 40px;
      background: #4c88ff;
      opacity: 0.8;
      margin-left: 1px;
    }
    // span:nth-child(2) {
    //   padding-top: 10px;
    //   .icon-full-screen {
    //     display: inline-block;
    //     width: 20px;
    //     height: 20px;
    //     background: url('../../../assets/images/ai-editor/full-screen.png')
    //       no-repeat;
    //     background-size: contain;
    //   }
    // }
    span:nth-child(2) {
      font-size: 20px;
      color: #ffffff;
      line-height: 40px;
    }

    .el-icon-d-arrow-left {
      position: fixed;
      top: 110px;
      right: 0;
      z-index: 9;
    }
  }
}

.excessive {
  width: 0;
  transition: width 0.3s;
}
</style>
